import { useEffect, useState } from "react";
import api from "../lib/api";
import { PublicLayout, SectionHeading, Testimonials } from "../components/PublicLayout";

export default function About() {
  const [about, setAbout] = useState(null);
  useEffect(() => { api.get("/site-content").then((r) => setAbout(r.data.about)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="about-page">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <SectionHeading eyebrow="About GloriPub" title={about?.heading || "We exist so great books don't die in drawers."} sub="" />
            <div className="space-y-4 text-neutral-600 leading-relaxed text-sm" data-testid="about-body">
              {(about?.paragraphs || []).map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </div>
          <img src="https://images.pexels.com/photos/1029141/pexels-photo-1029141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Books on shelves" className="rounded-2xl border border-neutral-200 shadow-sm object-cover w-full h-96" />
        </div>
        <SectionHeading eyebrow="Testimonials" title="Authors who trusted us with their words" />
        <Testimonials />
      </section>
    </PublicLayout>
  );
}
